import { useApi } from '#shared/providers/Api';
import useUsers from './useUsers';
import unwrap from './unwrap';

// Assigning/unassigning roles to a user, and reading which roles a user already holds. Used by
// UsersList (assigning a freshly-created role), CreateUserDrawer, ManageUserRolesDialog and
// UserPermissionsDrawer (role-locked permissions).
export default function useUserRoleAssignment() {
  const api = useApi();
  const { account } = useUsers();

  function assignUserRole(params: { Username: string; RoleID: number }) {
    return unwrap(api.assignUserRole(params, undefined, account.bearer));
  }

  function unassignUserRole(params: { Username: string; RoleID: number }) {
    return unwrap(api.unassignUserRole(params, undefined, account.bearer));
  }

  async function fetchUserRoleAssignments(params: { Username: string }) {
    return (await unwrap(api.fetchUserRoleAssignments(params, account.bearer))).Roles;
  }

  return { assignUserRole, unassignUserRole, fetchUserRoleAssignments };
}
